module.exports = __webpack_public_path__ + "media/images/svg-icon/chart-8c86d3beba521110954f9bf79ae64b1f.svg";